import { AccountTypeEnum } from 'apps/user/types/user.enum.type';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';

export const useTabFilter = (tabs: any[]) => {
  const { user } = useAppSelector(selectAccountDetails);
  const planAllowPage = user && JSON.parse(user.planAllowPage);
  const filterPredicate = (nav: { pageId: number | null }) => {
    if (user.accountType === AccountTypeEnum.CLIENT) {
      return planAllowPage.includes(nav.pageId) || !nav.pageId;
    }
  };
  return tabs.filter(filterPredicate);
};

export const useSideBarFilter = (tabs: any[]) => {
  const { user } = useAppSelector(selectAccountDetails);
  const filterPredicate = (nav: { main: string }) => {
    if (user.isStaffAgent) return nav;
    return nav.main !== 'prospects';
  };

  return tabs.filter(filterPredicate);
};
